<template>
  <div class="tab-plan authenticator-tab">
    <div class="authen-frame">
      <form class="row-frame dep-form-frame colu-12 form-row-gap ">
        <div class="colu colu-12">
          <div class="colu-10 switchTitle">
            {{ $t("Bao.auth_page_text_2") }}
          </div>
          <div class="colu-2 fields__item switchFrame">
            <input
              v-model="isChecked"
              type="checkbox"
              class="uiswitch style-orange"
              @click.prevent="getQrcodeAndUrl"
            >
          </div>
        </div>
        <div class="colu colu-12">
          <label class="colu-12 authenTitle-babel" for="コードをAuthenticatorアプリにコピーして、パスワードを設定します。">
            {{ google_auth_totp_status || isChecked ? $t("Bao.auth_page_text_4") : $t("Bao.auth_page_text_3") }}
          </label>
        </div>

        <template v-if="google_auth_totp_status || isChecked">
          <div class="colu colu-12">
            <div class="colu-12 inp-relative">
              <input id="コードをAuthenticatorアプリにコピーして、パスワードを設定します。" class=" for-input inpType" type="text" :value="qr_code_url">
              <button type="button" class="btn btn-keyChainCopy" @click="copyText(qr_code_url)" />
            </div>
          </div>

          <div class="authenBox">
            <div class="authenQR">
              <qrcode-vue :value="qr_code" :size="150" />
            </div>
            <div>
              {{ $t("Bao.auth_page_text_5") }}
              <a class="hyperlink" :href="storeLink" target="_blank">{{ $t("Bao.auth_page_text_6") }}</a>
            </div>
          </div>

          <div class="colu colu-12">
            <label class="colu-12 authenTitle-babel" for="Google Authenticatorアプリから6桁のコードを入力してください">
              {{ $t("Bao.auth_page_text_7") }}<span class="highlight-red-02">*</span></label>
          </div>

          <div class="colu colu-12">
            <div class="colu-12 inp-relative">
              <input
                id="Google Authenticatorアプリから6桁のコードを入力してください"
                v-model="authenticatorCode"
                class="colu-12 for-input inpType inp-float"
                type="text"
                :placeholder="$t('Bao.auth_modal_text_2')"
              >
              <div class="icon-inpInside icon-authen " />
            </div>
          </div>

          <div class="bank-promo-n form-submit-frame">
            <button
              :disabled="!authenticatorCode || authenticatorCode.length != 6 || actionLoading"
              type="button"
              class="btn-primary-gold btn-authen btn-goToAuthen-popup btn-mb-w-100"
              @click="checkCode"
            >
              <span>{{ $t("Bao.auth_page_text_8") }}</span>
            </button>
          </div>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
import { getGoogleQrcode, updateGoogleStatus } from '@/api/user'
import { showNotice, copyText } from '@/utils/tool'
import qrcodeVue from 'qrcode.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    'qrcode-vue': qrcodeVue
  },
  data() {
    return {
      isChecked: false,
      qr_code: null,
      qr_code_url: null,
      authenticatorCode: null,
      storeLink: this.getStoreLink(),
      actionLoading: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    google_auth_totp_status() {
      return this.user.authStatus
    }
  },
  mounted() {
    if (this.google_auth_totp_status && (!this.qr_code || !this.qr_code_url)) {
      this.getQrcodeAndUrl()
    }
  },
  methods: {
    getStoreLink() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        return 'https://apps.apple.com/app/google-authenticator/id388497605'
      } else if (ua.indexOf('android') > -1) {
        return 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
      }
      return 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
    },
    getQrcodeAndUrl() {
      getGoogleQrcode().then(response => {
        if (response.data.data.code === 0) {
          this.isChecked = !this.isChecked
          this.qr_code = response.data.data.qr_base64
          this.qr_code_url = response.data.data.qr_code_url
        } else {
          showNotice(response.data.msg)
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    copyText(msg) {
      copyText(msg, this.qr_code_url)
    },
    checkCode() {
      this.actionLoading = true

      updateGoogleStatus({
        status: this.google_auth_totp_status ? 0 : 1,
        opt_code: this.authenticatorCode
      }).then(response => {
        if (response.data.data.code === 0) {
          showNotice(response.data.data.message)
          this.authenticatorCode = null

          this.$store.commit('SET_GOOGLE_AUTH_STATUS', response.data.data.status)
        } else {
          showNotice(this.$t('Bao.auth_error_text'))
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally(() => {
        this.actionLoading = false
      })
    }
  }
}
</script>
